
<div class="content-header">
  <ng-content></ng-content>
</div>
